<template>
<b-row class="osteoarthritis disease-pages no-gutters">
  <b-col class="tool-border" cols="12">
    <b-col class="reduce-padding" cols="12">
      <wlpHeader :pageTitle="pageTitle" :pageImage="pageImage"></wlpHeader>
    </b-col>
    <b-col class="page-background-gradient reduce-padding" cols="12">
      <b-row class="page-content  no-gutters">
        <b-row class="body-sec no-gutters">
          <b-col class="reduce-padding top-section" cols="12">
            <b-row class="no-gutters">
              <b-col class="reduce-padding text-section" lg="8" md="8" cols="12">
                <div class="top-text-title bold-text">
                  <span v-if="userData.conditions.osteoarth">  {{$t('common.top-text-title3')}}</span><span v-if="!userData.conditions.osteoarth">  {{$t('common.top-text-title')}}</span>
                </div>
                <div class="top-text bottom-spacing" v-if="!userData.conditions.osteoarth">
                 {{$t('osteoarthritis.top-text')}}
                 </div>
                <div v-if="userData.conditions.osteoarth" class="top-text bottom-spacing top-text-checked" >
           {{$t('osteoarthritis.top-text2')}}
                </div>
                
              </b-col>
              <b-col class="reduce-padding check-section" lg = "4" md="4" cols="12">
                <b-row class="check-yes-section osteo-check no-gutters">
                  <div class="condition-checkboxes osteo-checkbox wlp-checkboxes">
                  <input type="checkbox" name="oaCondition" v-model="userData.conditions.osteoarth" id="oaCondition" value="oaCondition">
                  <label class="" for="oaCondition">
                      <div class="condition-label">  {{$t('osteoarthritis.condition-label-1')}} <br> {{$t('osteoarthritis.condition-label-2')}} <br> {{$t('osteoarthritis.condition-label-3')}}</div>
                  </label>
                </div>
                </b-row>
              </b-col>
            </b-row>
            <div class="top-hr" :class="{'top-hr-sp' : $i18n.locale=='sp'}"></div>
          </b-col>
          
          <b-col class="reduce-padding graph-col" lg="8" md="7" cols="12">
            <div v-if="!userData.conditions.osteoarth">
              <div class="graph-title risk-text graph-title-common bold-text">
                {{$t('graph.lineGraphTitle')}} {{$t('common.osteoarthritis2')}}  
              </div>
              <div class="graph-sub-title current-knee-text graph-title-common">
                ({{$t('osteoarthritis.oddRatio')}})<sup>a</sup>
              </div>
            </div>
            <div v-if="userData.conditions.osteoarth">
              <div class="graph-title max-knee-text graph-title-common bold-text">
               {{$t('osteoarthritis.maxKnee1')}} <br> {{$t('osteoarthritis.maxKnee2')}}
              </div>
              <div class="graph-sub-title lower-text graph-title-common">
                <span v-if="userData.adjustButtons.osteoarth>0">{{userData.adjustButtons.osteoarth}}% ({{$t('graph.lowerWeight')}}) </span>
                (%)
              </div>
            </div>
            <div class="graphs-div">
              <div class="bar-graph-div" v-if="userData.conditions.osteoarth">
                <barGraph :disease="'oa'" :barValues="userData.calc.oaReduction" :adjustSelection="userData.adjustButtons.osteoarth" :displayBars="true" :lblY=lblY :lblEndX="50" :lblStartX="0" :lblSkipX="5"></barGraph>
              </div>
              <div v-if="!userData.conditions.osteoarth">
                <lineChart :disease="diseaseType" :risk="userData.calc.osteoarth" :adjustSelection="userData.adjustButtons.osteoarth" :lblEndX="50" :lblStartY="start" 
                :lblEndY="end" :lblSkipY="skip" :confInt="this.userData.confInt.osteoarth"></lineChart>
              </div>
            </div>
            <!--<b-col class="graph-bottom osteo-graph-bottom" cols="12" v-if="!userData.conditions.osteoarth">-->
            <!--  <b-row class="no-gutters">-->
            <!--    <b-col class="reduce-padding legends order-lg-1 order-2" lg="4" cols="12">-->
            <!--      <div class="bottom-section-osteo">-->
            <!--          <div class ="weight-loss-txt before-loss">-->
            <!--            <div class="bullet blue"></div>-->
            <!--            <div class="bullet-text">Current Risk</div>-->
            <!--          </div>-->
            <!--          <div class ="weight-loss-txt osteo-after-loss">-->
            <!--            <div class="bullet green"></div>-->
            <!--            <div class="bullet-text">Adjusted Risk</div>-->
            <!--          </div>  -->
            <!--      </div>-->
            <!--    </b-col>-->
            <!--    <b-col class="reduce-padding x-label-title order-lg-2 order-1" lg="2" cols="12">-->
            <!--      <div class="">BMI</div>-->
            <!--    </b-col>-->
            <!--    <b-col class="odds-ratio order-lg-3 order-3 safari_only" lg="6" cols="12">-->
            <!--      <b-row class=" no-gutters">-->
            <!--        <sup>a</sup>Odds Ratio describes the risk of developing the condition versus a person of normal weight. 1.0 represents no increased risk.-->
            <!--      </b-row> -->
            <!--    </b-col>-->
            <!--  </b-row>-->
            <!--</b-col>-->
            <b-col class="graph-bottom osteo-graph-bottom" cols="12" v-if="!userData.conditions.osteoarth">
            <b-row class="no-gutters">
              <b-col class="reduce-padding legends order-lg-1 order-2" lg="4" cols="12">
                <b-row class=" no-gutters">
                  <b-col class="reduce-padding risk-bullets" md="4" lg="6" cols="12">
                    <div class="bullet blue"></div>
                    <div class="bullet-text" :class="{'bullet-text-sp' : $i18n.locale=='sp'}">{{$t('common.currentRisk')}} </div>
                  </b-col>
                  <b-col class="reduce-padding risk-bullets" md ="8" lg="6" cols="12">
                    <div class="bullet green" v-if="userData.adjustButtons.osteoarth>0" md="6" ></div>
                    <div class="bullet-text" :class="{'bullet-text-sp' : $i18n.locale=='sp'}" v-if="userData.adjustButtons.osteoarth>0"  md="6" >{{$t('common.adjustedRisk')}}</div>
                  </b-col>
                </b-row>
              </b-col>
              <b-col class="reduce-padding x-label-title order-lg-2 order-1" lg="2" cols="12">
                <div class="">{{$t('common.bmi')}}</div>
              </b-col>
              <b-col class="odds-ratio order-lg-3 order-3 safari_only" lg="6" cols="12">
                <div class=" no-gutters">
                  <sup class="edpcos-sup">a</sup>{{$t('osteoarthritis.linegraphFooter')}}
                </div>
              </b-col>
            </b-row>
          </b-col>
            <b-col class=" graph-bottom osteo-bar-graph-bottom bar-graph-bottom" v-if="userData.conditions.osteoarth">
              <b-row class="no-gutters">
                  <div class="bottom-section-osteo" :class="{'bottom-section-osteo-sp' : $i18n.locale=='sp'}" >
                      <div class ="weight-loss-txt before-loss">
                        <div class="bullet blue"></div>
                        <div class="bullet-text" :class="{'bullet-text-sp' : $i18n.locale=='sp'}">{{$t('common.beforeWeight')}}</div>
                      </div>
                      <div class ="weight-loss-txt after-loss">
                        <div class="bullet green" v-if="userData.adjustButtons.osteoarth>0"></div>
                        <div class="bullet-text" :class="{'bullet-text-sp' : $i18n.locale=='sp'}" v-if="userData.adjustButtons.osteoarth>0">{{$t('common.afterWeight')}}</div>
                      </div>  
                  </div>
              </b-row>
            </b-col>
            
          </b-col>
          <b-col class="reduce-padding adj-weight-col" md="4" cols="12">
            <b-row class="no-gutters">
              <b-col class="triangle-outer reduce-padding" cols="12">
                <div class = "triangle-img"></div>
              </b-col>
              <b-col class="osteo-box reduce-padding">
                <weightAdjustmentBox :disease="diseaseName" :condition="userData.conditions.osteoarth" :adjustSelection="userData.adjustButtons.osteoarth" @adjustPercUpdate="userData.adjustButtons.osteoarth=$event"></weightAdjustmentBox>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-row>

      <wlpNavigation :navButtons="['info','references','tnc','menu','back','next']" :currentScreen="7"></wlpNavigation>
    </b-col>
  </b-col>
</b-row>
</template>
<script>
  import scrollMixin from "../mixins/scrollMixin";
  import wlpHeader from '../components/wlpHeader.vue';
  import wlpNavigation from '../components/wlpNavigation.vue';
  import lineChart from '../components/lineChart.vue';
  import barGraph from '../components/barGraph.vue';
  import weightAdjustmentBox from '../components/weightAdjustmentBox.vue';
  import { mapGetters, mapMutations } from 'vuex';

  export default {
    name: "osteoarthritis",
    mixins: [scrollMixin],
    mounted: function() {
      this.scrollToTop();
      this.end = this.userData.gender==='Male'?6:3.5;
      this.skip = this.userData.gender==='Male'?1:0.5;
      this.start = this.userData.gender==='Male'?0:0.5;
      this.diseaseType = this.userData.gender==='Male'?'osteoarth-male':'osteoarth-female';
      this.getOaValues();
      this.markSectionComplete({section:'osteoarth'});
    },
    components: {
      'wlpHeader': wlpHeader,
      'wlpNavigation': wlpNavigation,
    'lineChart': lineChart,
    'weightAdjustmentBox': weightAdjustmentBox,
    'barGraph': barGraph,
    },

    data() {
      return {
        pageTitle: this.$t('common.osteoarthritis'),
         diseaseName: this.$t('common.osteoarthritis').toLowerCase(),
        pageImage: 'osteoarthritis-img',
        diseaseType: 'osteoarth-male',
        lblY: [this.$t('common.bmi'),this.$t('common.bmi')],
        start: 0,
        skip: 1,
        end: 6
      };
    },
    
     computed: {
    ...mapGetters('userData', ['userData']),
  },
  
  methods: {
    ...mapMutations('userData', ['saveCalculations', 'markSectionComplete']),
    
      getOaValues: function() {
        this.saveCalculations({
            data:{
              current: [0],
              adj5: [0],
              adj10: [8],
              adj15: [17],
              adj20: [26],
            }, section: 'oaReduction'});
          // console.log("**** OA BARS: "+JSON.stringify(this.userData.calc.oaReduction));
        },
  }
  };
</script>


<style lang="scss" scoped>
</style>
